import { gql } from '@apollo/client';

export const UPSERT_WORKSPACE = gql`
  mutation upsertWorkspace($input: UpsertWorkspaceInput!) {
    workspace: upsertWorkspace(input: $input) {
      id
    }
  }
`;
